import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.businessIntelligence}cumul/dashboards`;

export interface DashboardValue {
  id: string;
  name: string;
}

export const getCumulDashboard = async ({
  tenantId,
}: {
  tenantId?: string;
}): Promise<BackResponse<DashboardValue[]> | BackResponseFailure> => {
  try {
    return await apiCall<BackResponse<DashboardValue[]>>(
      buildUrl(ENDPOINT, {
        tenantId,
      }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
